<spinner [isRunning]="isDataLoading"></spinner>

<div *ngIf="showNoProjectsMessage" class="error-message">
  <mat-icon class="error-icon">error</mat-icon>
  <h3>{{ noProjectMessage }}</h3>
  <br>
  <span>{{ additionalNoProjectMessage }}</span>
</div>

<div *ngIf="!showNoProjectsMessage">
  <div class="dashboard-toolbar">
    <div class="dashboard-toolbar-actions">
      <div *ngIf="showDashboardSelector" class="dashboard-selector">
        <div class="dashboard-select-wrapper">
          <div class="dashboard-select-display" (click)="toggleDashboardDropdown()">
            <span>{{ selectedDashboardName }}</span>
            <mat-icon>arrow_drop_down</mat-icon>
          </div>
          <ul class="dashboard-select-options" *ngIf="dashboardDropdownOpen">
            <li *ngFor="let db of allDashboards"
                [class.active]="db.Id === selectedDashboardId"
                (click)="selectDashboardFromDropdown(db.Id)">{{ db.Name }}</li>
          </ul>
        </div>
        <a (click)="setAsDefault(selectedDashboardId)" title="Set as default" class="dashboard-star">
          <mat-icon [style.color]="isDefaultDashboard ? '#f9a825' : 'gray'">star</mat-icon>
        </a>
      </div>
      <a (click)="showSettingsModal = true" class="dashboard-settings-btn">
        <mat-icon>settings</mat-icon>
      </a>
    </div>
  </div>

  <dashboard-settings [(visible)]="showSettingsModal" [projectId]="project.ProjectId"
    (dashboardsChanged)="loadResolvedDashboard($event)"></dashboard-settings>

  <div class="main-container" *ngIf="!showNoProjectsMessage">
    <div class="dashboard">
      <div *ngIf="dashboardsLoading" class="dashboard-cards-loading">
        <mat-spinner diameter="36"></mat-spinner>
      </div>

      <div class="activity-grid" *ngIf="!dashboardsLoading">
        <mat-card class="activity-card"
                  [class.activity-card-chat-unread-border]="card.Type === 'Chat' && card.Count > 0"
                  *ngFor="let card of dashboardCards" (click)="onCardClick(card)">
          <mat-card-content>
            <p class="count-number" [appCountUp]="card.Count" [duration]="1000"></p>
            <div class="count-label">{{ getCardDisplayLabel(card) }}</div>
          </mat-card-content>
        </mat-card>
      </div>

      <!-- Project Details card -->
      <mat-card class="project-detail-card" *ngIf="isClearanceUser" (click)="doProjectDetail()">
        <mat-card-content>
          <mat-card-title>Project Details - {{project.ProjectName}}</mat-card-title>
          <div class="project-detail-grid">
            <div class="detail-item">
              <mat-icon>person</mat-icon>
              <span>{{ project.ContactName }}</span>
            </div>
            <div class="detail-item">
              <mat-icon>title</mat-icon>
              <span>{{ project.ContactTitle }}</span>
            </div>
            <div class="detail-item">
              <mat-icon>call</mat-icon>
              <span>{{ project.ContactPhoneNumber }}</span>
            </div>
            <div class="detail-item" (click)="openEmail(project.ContactEmail, $event)">
              <mat-icon>email</mat-icon>
              <span>{{ project.ContactEmail }}</span>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <!-- Create New Asset Button -->
  <button mat-fab color="accent" class="fab-new-item"
          *ngIf="!_authService.readOnly"
          (click)="createNewItem()"
          matTooltip="new item" matTooltipPosition="above">
    <mat-icon>add</mat-icon>
  </button>
</div>
